<div
  class="card dx-theme-text-color dx-theme-background-color"
  (click)="navigateToDetails()"
>
  <div class="card-wrapper" class="priority-{{ task.priority | lowercase }}">
    <div class="card-priority"></div>
    <dx-button icon="edit" (onClick)="notify($event)"></dx-button>
    <div class="card-content">
      <div class="card-subject dx-theme-text-color">{{ task.text }}</div>
      <div class="card-data">
        <span class="priority">{{ task.priority }}</span>
        <span class="date dx-theme-text-color">{{
          task.dueDate | date : 'MM/dd/yyyy'
        }}</span>
      </div>
      <div class="card-assignee">
        <span class="company dx-theme-text-color">{{ task.company }}</span>
        <dk-user-avatar
          [dataLetters]="getAvatarText(task.owner)"
        ></dk-user-avatar>
      </div>
    </div>
  </div>
</div>
